import{useLayoutEffect as r,useEffect as o}from"react";import{isBrowser as m}from"./is-browser.mjs.js";const s=m?r:o;export{s as useIsomorphicLayoutEffect};
